import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { QuickbooksCallbackComponent } from './quickbooks-callback/quickbooks-callback.component';
import { ProjectsComponent } from './projects/projects.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';

export const appRoutes: Routes = [
  // TEST ROUTE: minimal Highcharts demo for troubleshooting

  { path: '', component: LandingComponent },
  { path: 'quickbooks-callback', component: QuickbooksCallbackComponent },
  { path: 'auth', component: QuickbooksCallbackComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'progress',
    loadComponent: () =>
      import('./progress/progress.component').then((m) => m.ProgressComponent),
    canActivate: [AuthGuard],
  },
  { path: 'projects', component: ProjectsComponent, canActivate: [AuthGuard] },
  {
    path: 'tools/workload',
    loadComponent: () =>
      import('./tools/workload/workload.component').then(
        (m) => m.WorkloadComponent
      ),
  },
  {
    path: 'budget',
    loadComponent: () =>
      import('./budget/budget.component').then((m) => m.BudgetComponent),
    canActivate: [RoleGuard],
    data: { expectedRoles: ['god', 'dev', 'admin', 'finance', 'el', 'pm'] },
  },
  {
    path: 'tools/expenses',
    loadComponent: () =>
      import('./tools/expenses/expenses.component').then(
        (m) => m.ExpensesComponent
      ),
    canActivate: [RoleGuard],
    data: { expectedRoles: ['finance', 'admin', 'god'] },
  },

  {
    path: 'tools/dev',
    loadComponent: () =>
      import('./tools/dev/dev.component').then((m) => m.DevComponent),
    canActivate: [RoleGuard],
    data: { expectedRoles: ['god', 'dev'] },
  },
  {
    path: 'tools/harvest',
    loadComponent: () =>
      import('./tools/harvest/harvest.component').then(
        (m) => m.HarvestComponent
      ),
    canActivate: [RoleGuard],
    data: { expectedRoles: ['god', 'dev'] },
  },
  {
    path: 'template',
    loadComponent: () =>
      import('./template/template.component').then((m) => m.TemplateComponent),
  },
  {
    path: 'status',
    loadComponent: () =>
      import('./status/status.component').then((m) => m.StatusComponent),
    canActivate: [RoleGuard],
    data: { expectedRoles: ['god', 'dev'] },
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./admin/admin.component').then((m) => m.AdminComponent),
    canActivate: [RoleGuard],
    data: { expectedRoles: ['god', 'dev', 'admin'] },
  },

  { path: 'unauthorized', component: LandingComponent },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
